<template>
  <div class="p-fluid p-formgrid p-grid">
  <div class="p-field p-col-12 p-col-12">
    <DataTable
      :value="itemGroupLists"
      :paginator="true"
      :rows="10"
      class="p-datatable-responsive p-datatable-gridlines"
      data-key="id"
    >
      <Column header="S.N" headerStyle="width: auto">
        <template #body="slotProps">
          {{ slotProps.index + 1 }}
        </template>
      </Column>
      <Column header="Item Group" field="name" filterField="name" filterMatchMode="contains" headerStyle="width: 100%"/>
      <Column header="Action" headerStyle="width: auto">
        <template #empty>No record found</template>
        <template #body="slotProps">
          <!-- <button type="button" class="btn btn-success" @click="editItemGroup(slotProps.data)">
            <i class="fa fa-edit"/>
          </button>
          <Button class="btn btn-danger"  @click="openDialog(slotProps.data.id)">
            <i class="fa fa-trash" aria-hidden="true"></i>
          </Button> -->
          <Button icon="pi pi-pencil" class="p-button-success p-button-sm"
                  @click="editItemGroup(slotProps.data)"/>
          <Button icon="pi pi-trash" class="p-button-danger p-button-sm"
                  @click="openDialog(slotProps.data.id)"/>
        </template>
      </Column>
    </DataTable>
    </div>
    <Dialog v-model="dialogShow" @cancel="cancel" @deleted="deleteItemGroup"/>
  </div>
  <!-- </section> -->
</template>
<script>
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import Dialog from '../../layout/dialog'
import Button from 'primevue/button'

export default {
  name: 'itemGroupList',
  data() {
    return {
      dialogShow: false,
      deleteReason: '',
      accountId: '',
      show: false
    }
  },
  computed: {
    itemGroupLists() {
      return this.$store.state.itemgroup.itemGroupLists
    }
  },
  mounted() {
    this.itemGroupList()
  },
  methods: {
    async itemGroupList() {
      await this.$store.dispatch('loadItemGroupList')
    },
    async deleteItemGroup(value) {
      if (value.trim() === '') {
        let message = {
          message: 'Delete Reason cannot be empty.',
          messageType: 'error'
        }
        this.$emit('delete-message', message)
        this.dialogShow = true
        return
      }
      let deleteRe = {
        itemGroupId: this.accountId,
        deleteReason: value
      }
      let resp = await this.$store.dispatch('deleteItemGroup', deleteRe)
      if (resp.data.status === 'SUCCESS') {
        let message = {
          message: resp.data.message,
          messageType: 'success'
        }
        this.$emit('delete-message', message)
      } else {
        let message = {
          message: resp.data.message,
          messageType: 'warn'
        }
        this.$emit('delete-message', message)
      }
      this.closeDialog()
    },
    editItemGroup(data) {
      this.$emit('edit-group', data)
    },
    cancel(data) {
      this.show = false
      this.dialogShow = false
    },
    openDialog(id) {
      this.dialogShow = true
      this.accountId = id
    },
    closeDialog() {
      this.dialogShow = false
      this.deleteReason = ''
    }
  },
  components: {
    DataTable,
    Column,
    Dialog,
    Button
  }
}
</script>
<style>
/* .datatable {
  font-size: 15px !important;
}

._message {
  width: fit-content;
  float: right;
  margin-top: -2%;
  margin-right: 1%;
} */
</style>



// WEBPACK FOOTER //
// itemgrouplist.vue?bbe4fb74